import UserInput from "./UserInput";

export default class UpdateUserRequest {
  user_uuid: string | null;
  user: UserInput | null;
  password: string | null;
  new_password: string | null;

  constructor(
    user_uuid: string | null = null,
    user: UserInput | null = null,
    password: string | null = null,
    new_password: string | null = null
  ) {
    this.user_uuid = user_uuid;
    this.user = user;
    this.password = password;
    this.new_password = new_password;
  }
}
